/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux';
import HTML from '../../components/fields/HTML';
import update from 'react-addons-update'; // ES6
import { default as DT } from 'react-datetime'

var _ = require('lodash');

import components from '../../config/builder/components'
const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;

const getNodeKey = ({ node }) => node.key;

class Survey extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      surveydata: [],
      dsurveydata: [],
      selectedsurvey: {},
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",
      md: SectionConfig.md,
      sv: SectionConfig.sv,
      canDeleteApp: false,
      updatetrack: false,
      updateinfobooth: false,
      selectedtrack: {},
      selectedtrackname: '',
      trackname: '',
      infoboothname: '',
      sectionsactive: ["active", "", "", ""],
      trackvalue: '',
      infoboothdate: '',
      selectedinfobooth: {},
      selectedinfoboothname: '',
      addquestionname: "",
      addquestiontype: "",
      addquestionedit: false,
      addquestionkey: ""
    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.processDataForSaving = this.processDataForSaving.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";
    this.confirmDeleteApp = this.confirmDeleteApp.bind(this);
    this.getAutoIncrementedNumOfApps = this.getAutoIncrementedNumOfApps.bind(this);
    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }


  componentDidMount() {

  }

  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }
  savetoreduxandfirebase() {
    var data = this.processdataforfirebase(this.state.treeData);
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/surveys").set(data);
    this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'surveys', data: data });
  }

  doDelete(treeData) {
    console.log("Do delete ");
    console.log(treeData);
    console.log("Item to delete: " + this.state.pathToDelete);
    var data = treeData;
    var path = this.state.pathToDelete;


    //data= [{ tree_path: 0 },{ tree_path: 1 }];

    console.log(data);
    console.log(path);

    var nodes = removeNodeAtPath({
      treeData: data,
      path: path,
      getNodeKey: ({ node }) => node.key,
    })

    this.setState({
      treeData: nodes
    }, () => {
      console.log("DOne");
      console.log(this.state.treeData);
      this.savetoreduxandfirebase();
    });
    // this.processDataForSaving(nodes);
    this.refs.deleteDialog.hide()
  }


  cancelDelete() {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }





  processdataforfirebase(data) {
    var tracks = {};
    var infobooths = {};
    for (let index = 0; index < data.length; index++) {
      tracks[data[index].key] = {
        name: data[index].title,
        o: index
      }
      if (data[index].children) {
        for (let j = 0; j < data[index].children.length; j++) {
          var d = data[index].children[j];
          var infobooth = {};
          infobooth.name = d.title;
          infobooth.o = j;
          infobooth.date = d.date;
          infobooth.questions = d.questions ? d.questions : [];
          infobooth.track = data[index].key;
          infobooths[d.key] = infobooth;
        }
      }
    }

    return { tracks: tracks, survey: infobooths };
  }
  processDataForSaving(treeData) {
    var data = JSON.parse(JSON.stringify(treeData));
    var olddata = this.processdataforfirebase(this.state.treeData);
    var newdata = this.processdataforfirebase(data);
    if (_.isEqual(olddata, newdata)) {
      console.log("Do not save");
      this.setState({
        treeData
      });
    } else {
      console.log("Save data");
      data.map((d) => {
        if (d.children) {
          d.children.map(child => {
            child["track"] = d.key
          })
        }
      })
      console.log(newdata);
      this.setState({
        treeData: data
      }, () => {
        this.savetoreduxandfirebase();
      });
    }


    // this.setState({ treeData })

    // console.log(tosavedata);
    // this.saveNewMenuStructure(data);
    // this.props.addnewsection(treeData, this.props.params.sub);

  }




  refreshDataAndHideNotification(time = 3000) {
    //Hide notifications
    setTimeout(function () { this.setState({ notifications: [] }) }.bind(this), time);
  }



  surveyTabContent() {
    return (
      // <div className="center col-md-12 ml-auto mr-auto">

      <div>

        <button className="btn btn-primary" disabled={JSON.stringify(this.state.selectedsurvey) == "{}"} onClick={() => {
          console.log("Add question");
          this.refs.addquestion.show()

        }}> Add Question</button>

        <button className="btn btn-danger" disabled={JSON.stringify(this.state.surveydata) == JSON.stringify(this.state.dsurveydata)} onClick={() => {
          console.log("Save");
          console.log(this.state.surveydata);
          console.log(this.state.selectedsurvey);
          var toupdatesurveydata = [];

          this.state.surveydata.map(s => {
            console.log(s);
            var topushdata = {};
            topushdata["name"] = s.title;
            topushdata["type"] = s.type;
            if (s.type == "opt") {
              var options = [];
              var children = s.children ? s.children : [];
              children.map(c => {
                options.push({
                  name: c.title
                })
              })
              topushdata["options"] = options;
            }
            toupdatesurveydata.push(topushdata);

          })
          console.log(toupdatesurveydata);
          console.log(this.state.selectedsurvey.key);

          firebase.app.database().ref('myapps/' + this.props.params.sub + "/surveys/survey/" + this.state.selectedsurvey.key + "/questions").set(toupdatesurveydata);
          var completesurveydata = {
            name: this.state.selectedsurvey.name,
            o: this.state.selectedsurvey.o,
            track: this.state.selectedsurvey.track,
            questions: toupdatesurveydata,
            date: this.state.selectedsurvey.date
          };
          this.props.updatedataobjectbytypeandsubtype({
            eventkey: this.props.params.sub, type: "surveys", key: this.state.selectedsurvey.key, subtype: "survey", data: completesurveydata
          })
          window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The survey <b>" + this.state.selectedsurvey.name + "</b> has been saved.");
          var newtreedata = JSON.parse(JSON.stringify(this.state.treeData));
          newtreedata.map(el => {
            if (el.key === this.state.selectedsurvey.track) {
              el.children.map(cel => {
                if (cel.key == this.state.selectedsurvey.key) {
                  cel.questions = toupdatesurveydata
                }
              })
            }
          });
          this.setState({
            dsurveydata: JSON.parse(JSON.stringify(this.state.surveydata)),
            treeData: newtreedata,
          }, () => {
            console.log(this.state.treeData);
          });

        }}>Save Survey</button>
        <br />
        <div style={{ height: 500 }}>
          <SortableTree
            ref="sortablesurvey"
            maxDepth={2}
            treeData={this.state.surveydata}

            canDrop={(item) => {
              // console.log(item);
              if (item.nextParent) {
                if (item.nextParent.type) {
                  if (item.nextParent.type == "com") {
                    return false;
                  }
                }
              }
              if (item.nextPath.length == item.prevPath.length) {
                return true
              } else {
                return false;
              }
              // if (item.opt) {
              //   return true;
              // } else {
              //   return false;
              // }
            }}
            canNodeHaveChildren={(item) => {
              return true;
              // if (item.opt && item.opt=="opt") {
              //   return true;
              // } else {
              //   return false;
              // }
            }}
            onChange={treeData => this.setState({ surveydata: treeData })}
            getNodeKey={getNodeKey}
            generateNodeProps={({ node, path }) => ({

              buttons: [
                <ConditionalDisplay condition={node.type == "opt"} >
                  <button className="btn-primary" onClick={() => {
                    console.log("Clicked");
                    console.log(node);
                    console.log(path);
                    console.log("For infobooths");
                    console.log(node.title);
                    this.setState({
                      addoptionedit: false,
                      addquestionkey: node.key
                    }, () => {
                      this.refs.addoption.show()

                    });


                  }}>
                    Add Options
              </button>
                </ConditionalDisplay>
                ,
                <button className="btn-primary" onClick={() => {
                  console.log("Clicked");
                  console.log(node);
                  console.log(path);
                  if (path.length == 1) {
                    console.log("For mainn question");
                    console.log(node.title);
                    console.log(node);
                    this.setState({
                      addquestionedit: true,
                      addquestionname: node.title,
                      addquestionkey: node.key,
                      addquestiontype: node.type
                      // sectionsactive: ["", "active", "",""],
                      // trackname: node.title,
                      // updatetrack: true,
                      // selectedtrackname: node.title,
                      // selectedtrack: node
                    }, () => {
                      this.refs.addquestion.show()
                    });
                  } else {
                    console.log("For option");
                    console.log(node.title);
                    this.setState({
                      addquestionkey: path[0],
                      addoptionkey: node.key,
                      addoptionname: node.title,
                      addoptionedit: true

                    }, () => {
                      this.refs.addoption.show()

                    })
                  }
                }}>
                  <i className="material-icons">edit</i>
                </button>,
                <div>
                  &nbsp;&nbsp;
                <a onClick={() => {
                    console.log("Delete");
                    this.setState({ nodeToDelete: node, pathToDelete: path }, () => {
                      if (path.length == 1) {
                        this.refs.deletequestion.show();
                      } else {
                        this.refs.deleteoption.show();
                      }
                    });
                  }} >
                    <button className="btn-danger">
                      <i className="material-icons">delete</i>
                    </button></a>
                </div>,
              ],
            })}


          />
        </div>
      </div >)
  }
  sectionTabContent(treeData) {
    var data = JSON.parse(JSON.stringify(treeData))
    return (
      <div style={{ height: 400 }}>

        <SortableTree
          ref="sortableTree"
          maxDepth={2}
          treeData={this.state.treeData}
          canNodeHaveChildren={(item) => {
            if (item.date) {
              return false;
            } else {
              return true;
            }
          }}

          onChange={treeData => this.processDataForSaving(treeData)}
          getNodeKey={getNodeKey}
          generateNodeProps={({ node, path }) => ({

            buttons: [
              <ConditionalDisplay condition={path.length != 1} >
                <button className="btn-primary" onClick={() => {
                  console.log("Clicked");
                  console.log(node);
                  console.log(path);
                  console.log("For infobooths");
                  console.log(node.title);
                  var surveydata = [];
                  var surveyquestions = node.questions ? node.questions : [];
                  surveyquestions.map((s, index) => {
                    var so = {};
                    so["key"] = index;
                    so["title"] = s.name;
                    so["type"] = s.type;
                    so["subtitle"] = "Type:-" + (s.type == "com" ? "Comment" : "Option");
                    so["expanded"] = true;
                    var child = [];
                    if (s.options) {
                      s.options.map((o, i) => {
                        var sco = {};
                        sco["key"] = "q" + index + "o" + i;
                        sco["title"] = o.name;
                        sco["expanded"] = true;
                        child.push(sco);
                      })
                    }
                    so["children"] = child;
                    surveydata.push(so);
                  })
                  this.setState({
                    sectionsactive: ["", "", "", "active"],
                    selectedsurvey: node,
                    surveydata: surveydata,
                    dsurveydata: JSON.parse(JSON.stringify(surveydata))
                  })

                }}>
                  Edit Questions
              </button>
              </ConditionalDisplay>
              ,
              <button className="btn-primary" onClick={() => {
                console.log("Clicked");
                console.log(node);
                console.log(path);
                if (path.length == 1) {
                  console.log("For tracks");
                  console.log(node.title);
                  console.log(node);
                  this.setState({
                    sectionsactive: ["", "active", "", ""],
                    trackname: node.title,
                    updatetrack: true,
                    selectedtrackname: node.title,
                    selectedtrack: node
                  })
                } else {
                  console.log("For infobooths");
                  console.log(node.title);
                  this.setState({
                    sectionsactive: ["", "", "active", ""],
                    infoboothname: node.title,
                    updateinfobooth: true,
                    selectedinfoboothname: node.title,
                    selectedinfobooth: node,
                    trackvalue: node.track,
                    infoboothdate: node.date
                  })
                }
              }}>
                <i className="material-icons">edit</i>
              </button>,
              <div>
                &nbsp;&nbsp;
                <a onClick={() => {
                  this.refs.deleteDialog.show();
                  console.log("Delete");
                  this.setState({ nodeToDelete: node, pathToDelete: path })
                }} >
                  <button className="btn-danger">
                    <i className="material-icons">delete</i>
                  </button></a>
              </div>,
            ],
          })}


        />
      </div>)
  }



  confirmDeleteApp() {
    if (this.state.inputDelete.length > 0 && this.state.inputDelete === "delete") {
      firebase.app.database().ref(Config.appEditPath).remove();
      this.getAutoIncrementedNumOfApps();
      window.location = "#"
    } else alert(T.ts("Please write delete to confirm deleting the app"))
  }

  // checkIfCanDeleteApp(rabId) {
  //   var _this = this;
  //   var rab_pointers = firebase.app.database().ref("rab_pointers/apps_queue/" + rabId + "_both");
  //   rab_pointers.on('value', function (snapshot) {
  //     _this.setState({
  //       canDeleteApp: snapshot.val() ? false : true
  //     })
  //   });
  // }

  getAutoIncrementedNumOfApps() {
    var num_of_apps_ai = firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid + '/numOfApps');
    num_of_apps_ai.transaction(function (ai) {
      if (ai) {
        ai--;
      }
      return ai;
    }, function (e, done, ai) {
      firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid).update({
        numOfApps: ai.val()
      });
    });
  }
  wizzardsectionchange = () => {
    console.log("Section changed");
    this.setState({
      trackname: "",
      selectedtrack: {},
      selectedtrackname: '',
      updatetrack: false,
      updateinfobooth: false,
      selectedinfobooth: {},
      selectedinfoboothname: "",
      trackvalue: '',
      infoboothname: '',
      infoboothdate: '',
      dsurveydata: [],
      surveydata: [],
      selectedsurvey: {}
    })
  }


  basicInfoContent() {

    return (
      <div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Track name")}</label>
            <input value={this.state.trackname} name="name" onChange={(event) => {
              this.setState({ trackname: event.target.value })
            }} type="text" className="form-control" />
          </div>
        </div>
        <br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" onClick={() => {
            if (this.state.updatetrack) {
              console.log("Updating Track");

              console.log(this.state.trackname);
              console.log(this.state.selectedtrack);
              var nameoftrack = this.state.trackname;
              var keyoftrack = this.state.selectedtrack.key;
              this.setState((prevState) => {
                return {
                  treeData: prevState.treeData.map(
                    (content, i) => i === this.state.selectedtrack.o ? { ...content, title: this.state.trackname }
                      : content
                  ),
                  trackname: "",
                  updatetrack: false,
                  selectedtrackname: '',
                  selectedtrack: {},
                  sectionsactive: ["active", "", "", ""]
                }
              }, () => {
                console.log(this.state.treeData);
                firebase.app.database().ref("myapps/" + this.props.params.sub + "/surveys/tracks/" + keyoftrack + "/name").set(nameoftrack).then(() => {
                  console.log("Updated");
                }).catch(err => {
                  console.log(err);
                })
                this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'surveys', data: this.processdataforfirebase(this.state.treeData) });
                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The track <b>" + nameoftrack + "</b> has been updated.");

              });

            } else {
              console.log("Adding new track");
              console.log(this.state.trackname);
              var firebaseref = firebase.app.database().ref('myapps/' + this.props.params.sub + "/surveys/tracks").push();
              var key = firebaseref.key;
              console.log(key);
              var treedata = this.state.treeData;
              firebaseref.set({
                name: this.state.trackname,
                o: treedata.length
              })
              var nameoftrack = this.state.trackname;
              this.setState((prevState) => {
                return {
                  treeData: [...prevState.treeData, {
                    key: key,
                    title: this.state.trackname,
                    expanded: true,
                    o: treedata.length
                  }],
                  trackname: ""
                }
              }, () => {
                this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'surveys', data: this.processdataforfirebase(this.state.treeData) });
                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new track <b>" + nameoftrack + "</b> has been added. Check it in the tracks panel.");
              });
            }
          }} className="btn btn-primary" disabled={this.state.updatetrack ? (this.state.trackname == this.state.selectedtrackname) : !this.state.trackname}>{T.td(this.state.updatetrack ? "Update Track" : "Add Track")}</button>
        </div>

      </div>)
  }


  imagesContent() {

    return (
      <div className="center col-md-12 ml-auto mr-auto">
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Survey name")}</label>
            <input value={this.state.infoboothname} name="name" onChange={(event) => {
              this.setState({ infoboothname: event.target.value })
            }} type="text" className="form-control" />
          </div>


          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Survey Expire Date")}</label>
            <DT onChange={(event) => {
              console.log(event.valueOf());
              this.setState({
                infoboothdate: event.valueOf()
              })
            }}
              value={this.state.infoboothdate}
            />
          </div>
        </div>

        <br />
        <label>{T.td("Track name")}</label>
        <div className="form-group">
          <select className="form-control" value={this.state.trackvalue} onChange={(event) => {
            this.setState({ trackvalue: event.target.value });

          }}>
            <option disabled hidden value=''></option>
            {this.state.treeData.map(item => {
              return (
                <option value={item.key} key={item.key}>{item.title}</option>

              )
            })}

          </select>
        </div>
        <br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button"
            onClick={() => {
              console.log("infobooth clicked");
              console.log(this.state.infoboothname);
              console.log(this.state.trackvalue);
              console.log(this.state.infoboothdate);
              if (this.state.updateinfobooth) {
                console.log("Updating infobooth");
                var nameofinfobooth = this.state.infoboothname;

                var newtreedata = JSON.parse(JSON.stringify(this.state.treeData));
                console.log(this.state.selectedinfobooth);
                if (this.state.trackvalue == this.state.selectedinfobooth.track) {
                  newtreedata.map(content => {
                    if (content.key == this.state.trackvalue) {
                      content.children.map(child => {
                        if (child.key == this.state.selectedinfobooth.key) {
                          child["name"] = this.state.infoboothname;
                          child["title"] = this.state.infoboothname;
                          child["date"] = this.state.infoboothdate;
                          child["track"] = this.state.trackvalue;
                          child["questions"] = this.state.selectedinfobooth.questions ? this.state.selectedinfobooth.questions : [];
                        }
                      })
                    }
                  })
                } else {
                  newtreedata.map(content => {
                    if (content.key == this.state.selectedinfobooth.track) {
                      var children = [];
                      if (content.children) {
                        content.children.map(ch => {
                          console.log(ch.key);
                          console.log(this.state.selectedinfobooth.key);
                          if (ch.key == this.state.selectedinfobooth.key) {
                            console.log("equal")
                          } else {
                            console.log("not equal");
                            children.push(ch);
                          }
                        })
                      }
                      console.log("Here1");
                      console.log(content.children);
                      console.log(children);
                      content.children = children;
                    }
                    if (content.key == this.state.trackvalue) {
                      if (content.children) {
                        var o = content.children.length;
                        content.children.push({
                          date: this.state.infoboothdate,
                          questions: this.state.selectedinfobooth.questions ? this.state.selectedinfobooth.questions : [],

                          expanded: true,
                          key: this.state.selectedinfobooth.key,
                          name: this.state.infoboothname,
                          o: o,
                          title: this.state.infoboothname,
                          track: this.state.trackvalue,
                        })
                      } else {
                        content.children = [{
                          date: this.state.infoboothdate,
                          questions: this.state.selectedinfobooth.questions ? this.state.selectedinfobooth.questions : [],
                          expanded: true,
                          key: this.state.selectedinfobooth.key,
                          name: this.state.infoboothname,
                          o: 0,
                          title: this.state.infoboothname,
                          track: this.state.trackvalue,
                        }]
                      }

                    }
                  })

                }
                console.log(newtreedata);
                this.setState({
                  treeData: newtreedata,
                  infoboothname: "",
                  infoboothdate: '',
                  selectedtrack: {},
                  selectedinfoboothname: '',
                  selectedinfobooth: {},
                  sectionsactive: ["active", "", "", ""],
                  updateinfobooth: false
                }
                  , () => {
                    this.savetoreduxandfirebase();
                    window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The survey <b>" + nameofinfobooth + "</b> has been updated.");
                  });

              } else {
                console.log("Adding new track");
                var firebaseref = firebase.app.database().ref('myapps/' + this.props.params.sub + "/surveys/survey").push();
                var key = firebaseref.key;
                console.log(key);
                var childlength = 0;
                var nameofinfobooth = this.state.infoboothname;
                this.state.treeData.map(item => {
                  if (item.key == this.state.trackvalue) {
                    if (item.children) {
                      childlength = item.children.length;
                    }
                  }
                });
                console.log(this.state.treeData);

                var newtreedata = this.state.treeData.map(
                  (content, i) => content.key === this.state.trackvalue ? {
                    ...content,
                    children: [
                      ...(content.children ? content.children : []), {
                        key: key,
                        title: this.state.infoboothname,
                        name: this.state.infoboothname,
                        track: this.state.trackvalue,
                        expanded: true,
                        o: childlength,
                        date: this.state.infoboothdate
                      }
                    ]
                  }
                    : content
                );
                console.log(newtreedata);
                firebaseref.set({
                  name: this.state.infoboothname,
                  o: childlength,
                  track: this.state.trackvalue,
                  date: this.state.infoboothdate
                })
                this.setState({
                  treeData: newtreedata,
                  infoboothdate: '',
                  trackvalue: '',
                  infoboothname: '',
                }
                  , () => {
                    this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'surveys', data: this.processdataforfirebase(this.state.treeData) });
                    window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new survey <b>" + nameofinfobooth + "</b> has been added. Check it in the tracks panel.");
                  });
              }

            }}
            className="btn btn-primary"
            disabled={this.state.updateinfobooth ? ((this.state.infoboothname == this.state.selectedinfoboothname) && (this.state.trackvalue == this.state.selectedinfobooth.track) && (this.state.infoboothdate == this.state.selectedinfobooth.date) || !(this.state.infoboothname && this.state.trackvalue)) : !(this.state.infoboothname && this.state.trackvalue && this.state.infoboothdate)}>
            {T.td(this.state.updateinfobooth ? "Update Survey" : "Add Survey")}</button>
        </div>
      </div >

    )

  }

  componentWillMount() {
    var infoboothdata = {};
    var categoriestest = [];
    var categories = [];
    if (this.props.events[this.props.params.sub]) {
      if (this.props.events[this.props.params.sub].surveys) {
        infoboothdata = JSON.parse(JSON.stringify(this.props.events[this.props.params.sub].surveys));
        console.log(infoboothdata);
        var tracks = infoboothdata.tracks ? infoboothdata.tracks : {};
        var infobooths = infoboothdata.survey ? infoboothdata.survey : {};
        Object.keys(infobooths).map((infobooth) => {
          var d = infobooths[infobooth];
          d["key"] = infobooth;
          d["title"] = d.name;
          d["expanded"] = true;
          if ("children" in tracks[d.track]) {
            tracks[d.track].children.push(d);
          } else {
            tracks[d.track].children = [d];
          }
        });
        Object.keys(tracks).map(track => {
          var mdata = tracks[track];
          var children = mdata.children ? mdata.children : [];
          var data = {};
          if (children) {
            var sortedchildren = _.sortBy(children, "o");
            data["children"] = sortedchildren;
          }
          data["key"] = track;
          data["o"] = mdata.o;

          data["expanded"] = true;
          data["title"] = mdata.name;
          categoriestest.push(data);
        });
        categories = _.sortBy(categoriestest, "o");
      }
    }
    this.setState({
      treeData: categories
    });
    // console.log(JSON.stringify(categories));

  }
  render() {
    var tracktitle = this.state.updatetrack ? "Update Track" : "Add new Track";

    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td("Tracks"),
        active: this.state.sectionsactive[0],
        label1: T.ts("Drag n Drop them Also you can nest them"),
        label2: T.td("Track sections"),
        content: this.sectionTabContent(this.state.treeData)
      },
      {
        name: "sectionsadd",
        icon: "playlist_add",
        title: T.td("Add Track"),
        active: this.state.sectionsactive[1],
        label1: T.ts(tracktitle),
        content: this.basicInfoContent()
      },
      {
        name: "images",
        icon: "collections",
        title: T.td("Add Surveys"),
        active: this.state.sectionsactive[2],
        label1: T.td("Add Surveys"),
        content: this.imagesContent()
      },
      {
        name: "surveydata",
        icon: "subject",
        title: T.td("Survey Data"),
        active: this.state.sectionsactive[3],
        label1: T.ts("Drag n Drop them Also you can nest them"),
        label2: T.td("Survey Data"),
        content: this.surveyTabContent()
      }
    ];

    return (
      <div>
        <SkyLight hideOnOverlayClicked ref="deleteoption" title="">
          <span><h3 className="center-block">{T.ts("Delete Option")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Option name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.nodeToDelete.title}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => {
                this.refs.deleteoption.hide();
              }} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => {
                console.log("Delete Option");
                console.log(this.state.pathToDelete);
                console.log(this.state.nodeToDelete);
                var newsurveydata = this.state.surveydata;
                newsurveydata.map((n, index) => {
                  if (n.key == this.state.pathToDelete[0]) {
                    var children = n.children ? n.children : [];
                    children.map((c, i) => {
                      if (c.key == this.state.pathToDelete[1]) {
                        children.splice(i, 1)
                      }
                    })
                  }
                })
                this.setState({
                  surveydata: newsurveydata
                }, () => {
                  this.refs.deleteoption.hide();
                });
              }} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>
        <SkyLight hideOnOverlayClicked ref="deletequestion" title="">
          <span><h3 className="center-block">{T.ts("Delete Question")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Question name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.nodeToDelete.title}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => {
                this.refs.deletequestion.hide();
              }} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => {
                console.log("Delete question");
                console.log(this.state.pathToDelete);
                console.log(this.state.nodeToDelete);
                var newsurveydata = this.state.surveydata;
                newsurveydata.map((n, i) => {
                  if (n.key == this.state.pathToDelete[0]) {
                    newsurveydata.splice(i, 1)
                  }
                })
                this.setState({
                  surveydata: newsurveydata
                }, () => {
                  this.refs.deletequestion.hide();
                });
              }} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>
        <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Section name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.nodeToDelete.name}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDelete(this.state.treeData)} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>
        <SkyLight
          beforeClose={() => {
            this.setState({
              addoptionname: "",
              addoptionedit: false,
              addoptionkey: "",
              addquestionkey: ""
            })
          }}

          hideOnOverlayClicked ref="addoption" title="">
          <span><h3 className="center-block">{T.ts(this.state.addoptionedit ? "Edit Option" : "Add Option")}</h3></span>
          <div className="input-group">
            <span className="input-group-addon">
              <i className="material-icons">border_color</i>
            </span>
            <div className="form-group label-floating">
              <label className="control-label">{T.td("Option name")}</label>
              <input value={this.state.addoptionname} name="name" onChange={(event) => {
                this.setState({ addoptionname: event.target.value })
              }} type="text" className="form-control" />
            </div>
          </div>
          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => {
                this.refs.addoption.hide()
              }} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <button disabled={!(this.state.addoptionname)} className="col-sm-3 center-block"
              onClick={() => {

                console.log(this.state.addoptionname);
                console.log(this.state.addquestionkey);
                console.log(this.state.addoptionkey);
                var newsurveydata = this.state.surveydata;
                if (this.state.addoptionedit) {
                  console.log("Updating option");
                  newsurveydata.map((d, index) => {
                    if (d.key == this.state.addquestionkey) {
                      var children = d.children ? d.children : [];
                      children.map((c, i) => {
                        if (c.key == this.state.addoptionkey) {
                          c.title = this.state.addoptionname,
                            c.name = this.state.addoptionname
                        }
                      })

                    }
                  })
                  this.setState({
                    surveydata: newsurveydata
                  }, () => {
                    this.refs.addoption.hide()
                  });

                } else {
                  console.log("Adding option");
                  newsurveydata.map((d, index) => {
                    if (d.key == this.state.addquestionkey) {
                      var children = d.children ? d.children : [];
                      children.push({
                        title: this.state.addoptionname,
                        key: "q" + d.key + "o" + children.length,
                        name: this.state.addoptionname
                      });
                      d.children = children
                    }
                  })
                  this.setState({
                    surveydata: newsurveydata
                  }, () => {
                    console.log(this.state.surveydata);
                    this.refs.addoption.hide()
                  })
                }
              }} className="btn btn-danger center-block">{T.ts(this.state.addoptionedit ? "Edit Option" : "Add Option")}
            </button>

          </div>

        </SkyLight>

        <SkyLight
          beforeClose={() => {
            this.setState({
              addquestionname: "",
              addquestiontype: "",
              addquestionedit: false,
              addquestionkey: ""
            })
          }}

          hideOnOverlayClicked ref="addquestion" title="">
          <span><h3 className="center-block">{T.ts(this.state.addquestionedit ? "Edit Question" : "Add Question")}</h3></span>
          <div className="input-group">
            <span className="input-group-addon">
              <i className="material-icons">border_color</i>
            </span>
            <div className="form-group label-floating">
              <label className="control-label">{T.td("Question name")}</label>
              <input value={this.state.addquestionname} name="name" onChange={(event) => {
                this.setState({ addquestionname: event.target.value })
              }} type="text" className="form-control" />
            </div>



          </div>


          <label>{T.td("Question Type")}</label>
          <div className="form-group">
            <select className="form-control" value={this.state.addquestiontype} onChange={(event) => {
              this.setState({ addquestiontype: event.target.value });
            }}>
              <option disabled hidden value=''></option>

              <option value='opt'>Options Type</option>
              <option value='com'>Comment Type</option>
            </select>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => {
                this.refs.addquestion.hide()
              }} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <button disabled={!(this.state.addquestionname && this.state.addquestiontype)} className="col-sm-3 center-block"
              onClick={() => {

                console.log(this.state.addquestionname);
                console.log(this.state.addquestiontype);
                if (this.state.addquestionedit) {
                  console.log("Updating question");
                  console.log(this.state.addquestionkey);
                  var newsurveydata = this.state.surveydata;
                  newsurveydata.map((d, index) => {
                    if (d.key == this.state.addquestionkey) {
                      newsurveydata[index].title = this.state.addquestionname;
                      newsurveydata[index].name = this.state.addquestionname;
                      newsurveydata[index].type = this.state.addquestiontype;
                    }
                  })
                  this.setState({
                    surveydata: newsurveydata
                  }, () => {
                    this.refs.addquestion.hide()
                  });

                } else {
                  console.log("Adding question");

                  this.setState({
                    surveydata: [...this.state.surveydata, {
                      expanded: true,
                      key: this.state.surveydata.length,
                      title: this.state.addquestionname,
                      name: this.state.addquestionname,
                      subtitle: this.state.addquestiontype,
                      type: this.state.addquestiontype,
                      children: []
                    }]
                  }, () => {
                    console.log(this.state.surveydata);
                    this.refs.addquestion.hide()
                  })
                }
              }} className="btn btn-danger center-block">{T.ts(this.state.addquestionedit ? "Edit Question" : "Add Question")}
            </button>

          </div>

        </SkyLight>

        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>

          <Wizzard
            title={"Surveys"}
            steps={theSteps}
            stepsActivity={this.state.sectionsactive}
            wizzardsectionchange={this.wizzardsectionchange}
          />
        </div>
      </div>)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updateobjectwithtracks: dispatch.eventmodel.updateobjectwithtracks,
  updatedataobjectbytypeandsubtype: dispatch.eventmodel.updatedataobjectbytypeandsubtype
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Survey);


// WEBPACK FOOTER //
// ./src/containers/Builder/survey.js